import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Globals } from '../../../../_globals';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { CategoryService } from '../../../../_services/category.service';
import { ObjectFilterPipe } from '../../../../_pipes/object-filter.pipe';
import { TreeNode } from 'primeng/api';

import { Product } from '../../../../_models/product.model';

@Component({
  selector: 'app-product-categories-form-dialog',
  templateUrl: './product-categories-form.component.html',
})
export class ProductCategoriesFormComponent implements OnInit {
  @Input() product: Product;
  @Input() store: any;
  @Input() products?: Product[];

  categories: any[] = [];
  displayCategories: TreeNode[] = [];

  selectedCategory = { label: 'No Category Selected', id: null, name: null, data: { id: null } };

  constructor(
    public globals: Globals,
    public router: Router,
    public fb: FormBuilder,
    public objectFilter: ObjectFilterPipe,
    public _categoryService: CategoryService
  ) {}

  ngOnInit() {
    this.getAllCategories();
  }

  getAllCategories() {
    this.categories = [];
    this.displayCategories = [];
    this._categoryService.getItemCategoriesByStoreId(this.store.id).subscribe((data: any) => {
      this.categories = data;
      this.filterRootItemCategories(null);
    });
  }

  public filterRootItemCategories(categoryId) {
    const catId = categoryId;
    const filteredCats = this.objectFilter.transform(
      this.categories,
      'parentItemCategoryId',
      catId
    );
    this.populateTreeMenu(filteredCats);
  }

  public populateTreeMenu(array) {
    const filteredArray = array;
    filteredArray.forEach((element) => {
      // console.log(element);
      const treeNodeObject = {
        label: element.name,
        data: element,
        id: element.id,
        parent: element.parentItemCategoryId,
        expandedIcon: 'fa fa-folder-open',
        collapsedIcon: 'fa fa-folder',
        leaf: false,
      };
      this.displayCategories.push(treeNodeObject);
    });
  }

  public loadNode(event) {
    if (event.node) {
      const parentId = event.node.data.id;
      const children = this.objectFilter.transform(
        this.categories,
        'parentItemCategoryId',
        parentId
      );
      children.forEach((element) => {
        element.label = element.name;
        element.data = element;
        element.parent = element.parentItemCategoryId;
        element.expandedIcon = 'fa fa-folder-open';
        element.collapsedIcon = 'fa fa-folder';
        element.leaf = false;
      });
      event.node.children = children;
    }
  }

  public nodeSelect(event) {
    this.selectedCategory.label = event.node.data.name;
    this.selectedCategory.id = event.node.data.id;
    this.selectedCategory.data = event.node.data;


    if(this.products){
      this.products.forEach(element => {
        element.categoryId = event.node.data.id;
     });
    }
    else {
      this.product.categoryId = event.node.data.id;
    }
  }
  
}


// WEBPACK FOOTER //
// ./src/app/components/forms/products/product-categories-form/product-categories-form.component.ts